export default __webpack_public_path__ + "static/media/Orbitron-Regular.1f498717.ttf";